const selectManifestationStatusOptions = [
  { id: 1, name: 'Pendente', color: '#e6c300' },
  { id: 2, name: 'Recusado', color: '#e62200' },
  { id: 3, name: 'Concluído', color: '#37a329' },
  { id: 4, name: 'Tentativa de contato', color: '#6585e7' },
];

export default selectManifestationStatusOptions;
